import type { IViewPortOrientation } from '@/engine/app/interfaces';
import type { CallbackSubscription } from '@/engine/Utilities/CallbackManager';
import type { ICubeControlIntegrationApi } from '../cubeControl/interfaces';
import type { DefaultOrientationProvider } from './DefaultOrientationProvider';
import { ViewPortManipulationApiBase } from './ViewPortManipulationApiBase';
import type * as THREE from 'three';

export class CubeControlIntegrationApi extends ViewPortManipulationApiBase implements ICubeControlIntegrationApi {
  private readonly _orientationProvider: DefaultOrientationProvider;

  public constructor(orientationProvider: DefaultOrientationProvider) {
    super();
    this._orientationProvider = orientationProvider;
  }

  // ICubeControlIntegrationApi

  public trackCameraOrientationChanges(callback: (quaternion: THREE.Quaternion) => void): CallbackSubscription {
    return this._trackParentOrientation(callback);
  }

  public trackModelFrontOrientationChanges(callback: (orientation: IViewPortOrientation) => void): CallbackSubscription {
    return this._orientationProvider.trackModelFrontOrientationChanges(callback);
  }

  public getCameraOrientation(): THREE.Quaternion {
    return this._getParentOrientation();
  }

  public async getModelFrontOrientation(): Promise<IViewPortOrientation> {
    const orientation = await this._orientationProvider.getModelFrontOrientation();
    return orientation;
  }

  public updateParentOrientation(
    topVector: THREE.Vector3,
    direction: THREE.Vector3,
    centrify?: boolean,
    centerPoint?: THREE.Vector3
  ): void {
    this._getViewPortController().setupCamera({ topVector: topVector, directionVector: direction });
    if (centrify) {
      this._getCameraController().centrifyCamera(centerPoint ?? this._getCenterPoint(), true);
    }
  }
}
